import { useEffect, useState } from 'react'
import { useAuth } from '../auth'
import { useI18n } from '../i18n'
import { avvZustand } from '../lib/avv'
import { Button, Sheet } from '../ui/kit'
import { AvvBestandsAnnahme } from './AvvGate'
export default function AvvBanner() {
  const { avv, rolle, mode, tenantId, session } = useAuth()
  const { lang } = useI18n()
  const [open, setOpen] = useState(false)
  useEffect(() => setOpen(false), [tenantId, session?.user.id])
  const state = avvZustand(avv, rolle)
  if (mode !== 'live' || state === 'keiner') return null
  return <div className="p-3 text-sm bg-accent-soft space-y-2">
    <p>{lang === 'de' ? 'Der Inhaber muss den Auftragsverarbeitungsvertrag annehmen.' : 'The account owner needs to accept the data processing agreement.'}</p>
    {rolle === 'owner' && <>
      <Button type="button" size="sm" onClick={() => setOpen(true)}>{lang === 'de' ? 'Jetzt annehmen' : 'Accept now'}</Button>
      <Sheet open={open} onClose={() => setOpen(false)} title={lang === 'de' ? 'Auftragsverarbeitung' : 'Data processing agreement'}>
        <AvvBestandsAnnahme key={`${session?.user.id}:${tenantId}`} gate={false} onDone={() => setOpen(false)} />
      </Sheet>
    </>}
  </div>
}
